import React from 'react'

// css
import 'assets/style/elements/input-radio.scss'

function Element({ name = '', title, value, checked = false, className, onChange = () => {}, styleYn = false }) {
  return (
    <label className={styleYn ? 'input-radio-sm' : 'input-radio'}>
      <input name={name} type="radio" className={className} value={value} checked={checked} onChange={onChange} />
      <span className="label">{title}</span>
    </label>
  )
}

export default Element
